import { useDispatch } from "react-redux";
import { api } from "@app/api/carApi.manual";
import { clearAuth } from "@app/redux/authSlice";
import { useMemo } from "react";

export const useLogout = () => {
  const dispatch = useDispatch();

  return useMemo(() => {
    const logout = () => {
      dispatch(clearAuth());
      dispatch(api.util.resetApiState());
      localStorage.clear();
      sessionStorage.clear();
    };

    return {
      logout,
    };
  }, [dispatch]);
};
